import React from 'react';
import PropTypes from 'prop-types';

const EffectCursorPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M18.483 17.1l4.973 7.373a1 1 0 0 1-.27 1.388l-.829.56a1 1 0 0 1-1.388-.27l-5.085-7.539-3.328 4.48c-.475.275-.866.207-1.055-.12-.097-.168-.14-.405-.115-.7L10.27 7.456c.075-.87.753-1.218 1.507-.786l12.245 8.225c.758.434.781 1.128.067 1.54l-5.606.666z"
    />
  );
};

EffectCursorPath.propTypes = {
  fill: PropTypes.string,
};

export default EffectCursorPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/effects/effect-cursor.jsx